import React from 'react'
import { Box, Typography } from '@mui/material'
import { MultiTableConfigTable } from '../../../../types/gotypes'
import { TableSourcePicker } from './TableSourcePicker'
import { FilesComingSoonSlot } from './FilesComingSoonSlot'

export interface WizardStep1SourcesProps {
  customer: string
  job: string
  tables: MultiTableConfigTable[]
  onTablesChange: (tables: MultiTableConfigTable[]) => void
}

/**
 * Step 1 — browse tables & files, job-scoped (#970 Part A, #961).
 *
 * #1176: the tree is the main control on this screen, so it gets the space —
 * the picker uses the flat editor's two-column layout (selected tables beside
 * the tree) and grows with the step, instead of a 260px strip in a 640px
 * column with the selection shown twice. The "Browse files" placeholder is
 * one quiet line.
 */
export const WizardStep1Sources: React.FC<WizardStep1SourcesProps> = ({ customer, job, tables, onTablesChange }) => (
  <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1.5, width: '100%', minHeight: 0 }}>
    {/* No job label (#1132): a dashboard is single-job and this flow never
        offers another — the slug here was noise. */}
    <Typography variant="h6">What data would you like the AI to work from?</Typography>

    <TableSourcePicker
      customer={customer}
      job={job}
      selected={tables}
      onSelectedChange={onTablesChange}
      layout="columns"
    />

    <FilesComingSoonSlot />
  </Box>
)

export default WizardStep1Sources
